var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('vue-progress-bar'),_c('router-view'),_c('IdleWarningModal',{attrs:{"is-idle":_vm.isIdle,"time-left":_vm.timeLeft,"stay-logged-in":_vm.stayLoggedIn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }